import { BrandMark } from '@sentinel/web-core';
import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { useActiveMission } from '@/core/mission/active-mission';

/** Mark and name; under the name the alert level of the active operation, next to the node
 *  that carries its colour: the only two places of the level (rule 4). */
export function Brand() {
  const { t } = useTranslation();
  const { mission } = useActiveMission();
  return (
    <Link to="/" className="brand">
      <BrandMark size={30} level={mission?.alertLevel} />
      <span>
        <b>{t('shell.brand.product')}</b>
        {mission === null ? (
          <i>{t('shell.brand.suite')}</i>
        ) : (
          <span className={['lv', mission.alertLevel].join(' ')}>
            {t(`common.level.${mission.alertLevel}`)}
          </span>
        )}
      </span>
    </Link>
  );
}
